import React from "react";
import {
  CButton,
  CCardBody,
  CCol,
  CForm,
  CFormInput,
  CFormLabel,
  CRow,
  CSpinner,
} from "@coreui/react";
import { Formik, FieldArray } from "formik";
import { translation } from "@/constants/translation/translation.translation";
import { useNavigate } from "react-router-dom";

const TranslationForm = ({
  t,
  initialValues,
  validationSchema,
  onSubmit,
  isLoading,
  disabled = false,
}) => {
  const navigate = useNavigate();
  
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      enableReinitialize
      validateOnBlur={true}
      validateOnChange={true}
      validateOnMount={false}
    >
      {({ values, handleSubmit, handleChange, handleBlur, errors, touched }) => (
        <CForm onSubmit={handleSubmit}>
          <CCardBody>
            <CRow>
              <CCol>
                <CFormLabel>
                  {t(translation.form.keyword_label_text)}
                </CFormLabel>
                <CFormInput
                  type="text"
                  name="key"
                  placeholder={t(translation.form.keyword_placeholder)}
                  className="form-control same-input-cls"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.key}
                  disabled={disabled} // Use the disabled prop
                />
                {touched.key && errors.key && (
                  <div className="error text-danger mt-1">{t(errors.key)}</div>
                )}
              </CCol>
            </CRow>

            <FieldArray name="translations">
              {() => (
                <>
                  {values.translations.map((item, index) => {
                    return (
                    <CRow key={index} className="mt-3">
                      <CCol lg={6}>
                        <CFormLabel>
                          {t(translation.form.language_label_text)}
                        </CFormLabel>
                        <CFormInput
                          type="text"
                          value={typeof item === 'object' ? (item.language || item.displayName || `Language ${index + 1}`) : item}
                          disabled
                        />
                      </CCol>
                      <CCol lg={6}>
                        <CFormLabel>
                          {t(translation.form.value_label_text)}
                        </CFormLabel>
                        <CFormInput
                          name={`translations[${index}].title`}
                          placeholder={t(translation.form.value_placeholder)}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.translations[index].title}
                        />
                        {touched.translations?.[index]?.title && errors.translations?.[index]?.title && (
                          <div className="error text-danger mt-1">
                            {t(errors.translations[index].title)}
                          </div>
                        )}
                      </CCol>
                    </CRow>
                    );
                  })}
                </>
              )}
            </FieldArray>

            <CRow className="text-center mt-4">
              <CCol className="d-flex gap-2 justify-content-center">
                <CButton color="primary" className="px-4" type="submit">
                  {isLoading ? (
                    <>
                      <CSpinner size="sm" variant="grow" /> &nbsp;{" "}
                      {t(translation.form.loading_btn_text)}
                    </>
                  ) : (
                    t(translation.form.submit_btn_text)
                  )}
                </CButton>
                <CButton
                  color="secondary"
                  className="px-4"
                  type="button"
                  disabled={isLoading}
                  onClick={() => navigate("/masters/translation/list")}
                >
                  {t(translation.form.cancel_btn_text)}
                </CButton>
              </CCol>
            </CRow>
          </CCardBody>
        </CForm>
      )}
    </Formik>
  );
};

export default TranslationForm;
